import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, Card, CardHeader, CardBody } from "shards-react";

import { FaAndroid, FaApple } from "react-icons/fa"; 

import "./loaderStyles.css";
import { useAuth } from '../../context/AuthContext';
const severityColors = {
  high: { border: "#dc3545", background: "#f8d7da", text: "#721c24" },
  medium: { border: "#ffc107", background: "#fff3cd", text: "#856404" },
  low: { border: "#28a745", background: "#d4edda", text: "#155724" }
};

const SalesByCategory = ({ title, os }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [warning, setWarning] = useState(null);
  const { logout } = useAuth(); 
  useEffect(() => {
    const fetchData = async () => {
      const companyId = localStorage.getItem("company_id");
      const token = localStorage.getItem("token");
     
        if(!companyId||companyId==''||!token||token==''){ 
         logout();
       }

       
       if(!companyId||companyId==''||!token||token==''){ 
        setWarning("Company ID not found in local storage. Please set it and try again.");
        setLoading(false);
        logout();
        return;
      }

      try {
        const response = await fetch("https://vaptlabreport.com/shieldapi/top_threats.php", {
          method: "POST",
          headers: { "Content-Type": "application/json",   Authorization: `Bearer ${token}`, },
          body: JSON.stringify({ company_id: companyId, os })
        });

        if (!response.ok) throw new Error("Failed to fetch data from the server.");

        const data = await response.json();

        if (data.status === "error" || !data.data || Object.keys(data.data).length === 0) {
          setWarning("No data available for the provided company ID.");
        } else {
          const formattedCategories = Object.entries(data.data).map(([title, { severity, count }]) => ({
            title, value: count, severity
          }));
          setCategories(formattedCategories);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setWarning("Error fetching data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [os]);

  const renderIcon = () => {
    if (os === "android") return <FaAndroid style={{ color: "#3ddc84", marginRight: "8px" }} />;
    if (os === "ios") return <FaApple style={{ color: "#000", marginRight: "8px" }} />;
    return null;
  };

  return (
    <Card small className="sc-stats h-100">
      <CardHeader className="border-bottom">
        <h6 className="m-0">
          {renderIcon()}
          {title}
        </h6>
        <div className="block-handle" />
      </CardHeader>

      {/* <CardBody className="p-0">
        <Container fluid>
          {loading ? (
            <Row className="px-3 align-items-center">
              <Col className="text-center">
                <div className="spinner" />
                <p>Loading...</p>
              </Col>
            </Row>
          ) : warning ? (
            <Row className="px-3 align-items-center">
              <Col className="text-center">
                <p className="text-warning">{warning}</p>
              </Col>
            </Row>
          ) : categories.length === 0 ? (
            <Row className="px-3 align-items-center">
              <Col className="text-center">
                <p>No data available.</p>
              </Col>
            </Row>
          ) : (
            categories.map((item, idx) => (
              <Row key={idx} className="px-3 align-items-center">
                <Col className="sc-stats__title">{item.title}</Col>
                <Col className="sc-stats__value text-right">{item.value}</Col>
                <Col className="sc-stats__severity text-right">
                  <div 
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '80px',
                      padding: '4px',
                      border: `1px solid ${severityColors[item.severity].border}`,
                      borderRadius: '4px',
                      color: severityColors[item.severity].text,
                      fontWeight: '600',
                      fontSize: '0.875rem',
                      backgroundColor: severityColors[item.severity].background,
                      marginLeft: '50px'
                    }}
                  >
                    {item.severity.charAt(0).toUpperCase() + item.severity.slice(1)}
                  </div>
                </Col>
              </Row>
            ))
          )}
        </Container>
      </CardBody> */}

<CardBody className="p-0">
  <Container fluid>
    {loading ? (
      <Row className="px-3 align-items-center">
        <Col className="text-center">
          <div className="spinner" />
          <p>Loading...</p>
        </Col>
      </Row>
    ) : warning ? (
      <Row className="px-3 align-items-center">
        <Col className="text-center">
          <p className="text-warning">{warning}</p>
        </Col>
      </Row>
    ) : categories.length === 0 ? (
      <Row className="px-3 align-items-center">
        <Col className="text-center">
          <p>No data available.</p>
        </Col>
      </Row>
    ) : (
      <div 
        className={categories.length === 1 ? "single-row-wrapper" : "multi-row-wrapper"}
      >
        {categories.map((item, idx) => (
          <Row key={idx} className="px-3 align-items-center">
            <Col className="sc-stats__title">{item.title}</Col>
            <Col className="sc-stats__value text-right">{item.value}</Col>
            <Col className="sc-stats__severity text-right">
              <div 
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '80px',
                  padding: '4px',
                  border: `1px solid ${severityColors[item.severity].border}`,
                  borderRadius: '4px',
                  color: severityColors[item.severity].text,
                  fontWeight: '600',
                  fontSize: '0.875rem',
                  backgroundColor: severityColors[item.severity].background,
                  marginLeft: '50px'
                }}
              >
                {item.severity.charAt(0).toUpperCase() + item.severity.slice(1)}
              </div>
            </Col>
          </Row>
        ))}
      </div>
    )}
  </Container>
</CardBody>


    </Card>
  );
};

SalesByCategory.propTypes = {
  title: PropTypes.string,
  os: PropTypes.string
};

SalesByCategory.defaultProps = {
  title: "Top Threats",
  os: "android"
};

export default SalesByCategory;
